import React, { useState, useEffect } from "react";
import SyncIcon from "@mui/icons-material/Sync";

export default function RefreshButton(props) {
  const [disabled, setDisabled] = useState(true); // initially disabled
  const [lastClicked, setLastClicked] = useState(new Date());
  const [timeAgo, setTimeAgo] = useState("");
  const [loading, setLoading] = useState(false);

  // Disable for 10 sec on initial load
  useEffect(() => {
    const timer = setTimeout(() => {
      setDisabled(false);
    }, 10 * 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = async () => {
    if (disabled || loading) return;

    setLoading(true);

    try {
      await props.onRefresh();

      const now = new Date();
      setLastClicked(now);
      setDisabled(true); // disable immediately

      //  Disable again for 10 sec after click
      setTimeout(() => {
        setDisabled(false);
      }, 10 * 1000);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ⏱ Time ago updater
  useEffect(() => {
    if (!lastClicked) return;

    const interval = setInterval(() => {
      const secondsAgo = Math.floor(
        (Date.now() - lastClicked.getTime()) / 1000
      );

      if (secondsAgo < 60) {
        setTimeAgo(`${secondsAgo} seconds ago`);
      } else if (secondsAgo < 3600) {
        setTimeAgo(`${Math.floor(secondsAgo / 60)} minutes ago`);
      } else {
        setTimeAgo(`${Math.floor(secondsAgo / 3600)} hours ago`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [lastClicked]);

  return (
    <div className={props.className}>
      {lastClicked && (
        <span className="review-text small-text">
          Last refreshed: {timeAgo}
        </span>
      )}

      <button
        className="btn btn-sm"
        onClick={handleClick}
        disabled={disabled || loading}
      >
        <SyncIcon />
{/*          {loading ? "Refreshing..." : "Refresh"} */}
      </button>
    </div>
  );
}